module.exports = __webpack_public_path__ + "static/media/cancel.3741a2c6.svg";